// Busca (/search) e "También te puede interesar" do motor. Os produtos vêm do Worker (/api/pilot/*), que só devolve os
// da experiência do domínio. O preço sai como nos cards da loja: formato da Shopify (shop.money_format, que a seção
// põe em data-money-format) e sem centavos zerados, igual ao money_without_trailing_zeros que o motor usa em todo o
// tema (theme.mjs → withoutTrailingCents): "$27.590", não "$ 27.590" nem "$27.590,00".
const MONEY_SEPARATORS = {
  amount: [',', '.'],
  amount_no_decimals: [',', ''],
  amount_with_comma_separator: ['.', ','],
  amount_no_decimals_with_comma_separator: ['.', ''],
  amount_with_space_separator: [' ', ','],
  amount_no_decimals_with_space_separator: [' ', ''],
  amount_with_period_and_space_separator: [' ', '.'],
  amount_with_apostrophe_separator: ["'", '.'],
};

class PilotDiscovery extends HTMLElement {
  // Valor em centavos (ARS: 2 casas). Sem formato (HTML antigo em cache), o formato anterior.
  static formatMoney(cents, format) {
    const value = Math.round(Number(cents) || 0);
    if (!format) return new Intl.NumberFormat('es-AR', {style:'currency',currency:'ARS',maximumFractionDigits:0}).format(value / 100);
    const absolute = Math.abs(value);
    return format.replace(/{{\s*(\w+)\s*}}/g, (_, placeholder) => {
      const separators = MONEY_SEPARATORS[placeholder];
      if (!separators) return '';
      const [thousands, decimal] = separators;
      const withCents = decimal !== '' && absolute % 100 !== 0;
      const whole = String(withCents ? Math.floor(absolute / 100) : Math.round(absolute / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return (value < 0 ? '-' : '') + whole + (withCents ? decimal + String(absolute % 100).padStart(2, '0') : '');
    });
  }
  // Busca com a 1ª página já no HTML (o Worker escreveu data-total): não pede de novo; "Ver más" segue da página 2.
  connectedCallback() { if (!('total' in this.dataset)) this.load(); this.querySelector('[data-more]')?.addEventListener('click', () => { this.page = (this.page || 1) + 1; this.load(true); }); }
  async load(append = false) {
    const status = this.querySelector('[aria-live]');
    const result = this.querySelector('[data-results]');
    try {
      const url = new URL(this.dataset.product ? '/api/pilot/recommendations' : '/api/pilot/search', location.origin);
      if (this.dataset.product) url.searchParams.set('product_id', this.dataset.product);
      else url.searchParams.set('q', new URLSearchParams(location.search).get('q') || '');
      url.searchParams.set('page', this.page || 1);
      url.searchParams.set('limit', this.dataset.product ? 8 : 24);
      const response = await fetch(url);
      if (!response.ok) throw new Error('unavailable');
      const data = await response.json();
      if (!append) result.replaceChildren();
      for (const p of data.products) {
        const a = document.createElement('a'); a.className = 'pilot-card';
        if (!/^\/products\/[a-z0-9-]+$/.test(p.url)) continue;
        a.href = p.url;
        // Moldura da foto sempre presente: card sem foto não desalinha a grade.
        const media = document.createElement('span'); media.className = 'pilot-card__media';
        // Foto da Shopify ou do próprio domínio (/fotos/: fotos da vitrine fora da Shopify, no R2).
        if (p.image && (/^https:\/\/(?:cdn\.shopify\.com|[^/]+\.shopifycdn\.com)\//.test(p.image) || /^https:\/\/[^/]+\/fotos\/[a-f0-9]{24}\.jpg$/.test(p.image))) {
          // A foto original tem 1200 px; o card mostra no máximo ~300 px (no celular, ~180 px em 2 colunas): srcset 400/800
          // e o navegador escolhe pela largura do card (os mesmos atributos dos cards que o Worker desenha na busca).
          const sized = width => { const src = new URL(p.image); src.searchParams.set('width', String(width)); return src.href; };
          const img = document.createElement('img'); img.loading = 'lazy'; img.decoding = 'async'; img.width = 600; img.height = 600; img.alt = p.title;
          img.sizes = 'auto, (min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw'; img.srcset = `${sized(400)} 400w, ${sized(800)} 800w`; img.src = sized(600);
          media.append(img);
        }
        const title = document.createElement('span'); title.className = 'pilot-card__title'; title.textContent = p.title;
        const price = document.createElement('strong'); price.className = 'pilot-card__price'; price.textContent = PilotDiscovery.formatMoney(p.price, this.dataset.moneyFormat);
        a.append(media, title, price); result.append(a);
      }
      status.textContent = data.total ? data.total + ' productos' : 'No encontramos productos.';
      const more = this.querySelector('[data-more]'); if (more) more.hidden = result.children.length >= data.total;
    } catch { status.textContent = 'No pudimos cargar los productos. Intenta nuevamente.'; }
  }
}
if (!customElements.get('pilot-discovery')) customElements.define('pilot-discovery', PilotDiscovery);
